import styled from "styled-components";
import { color } from "styled-system";

export const MultiWeekPlannerMainContainer = styled("section")`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const TableSection = styled("div")`
  flex: 1;
  display: flex;
  padding: 1em;
  flex-direction: column;
  align-items: stretch;
`;

export const AssumptionSummaryText = styled("h3")`
  text-align: center;
`;

export const VisualisationSection = styled("div")`
  flex: 1;
  display: flex;
  align-items: stretch;
`;

export const PeakCartonCountContainer = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 1em 1.5em;
  max-height: 5em;
  flex: 1;
  font-size: 1.4em;
  ${(props) =>
    props.bold &&
    `
   font-weight: bold;
   `};
`;

export const VolumeGridWrapper = styled("div")`
  display: flex;
  flex-direction: column;
`;

export const VolumeGridRow = styled("div")`
  display: flex;
  flex-direction: row;
`;

export const TableWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  &:last-child {
    border-bottom: none;
  }
`;

export const TableRow = styled("div")`
  display: flex;
  flex-direction: row;
  flex: 1;
  border-bottom: 1px solid #e0e0e0;
  & .headercell {
    background-color: #e0e0e0;
    color: black;
    font-weight: bold;
  }
`;

export const TableCell = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 0.5em;
  text-align: center;
  border-right: 1px solid #e0e0e0;
  &:last-of-type: {
    borde: none;
  }
`;

export const NoScenarioText = styled("h1")`
  color: #ddd;
`;

export const NoDataMessage = styled.h1`
  color: #ddd;
  font-size: 1.5em;
`;

export const NoVisualisationDataWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
